<template>
  <section class="secForm password-recovery">
    <div class="mask" v-if="showMask" @click="hideAllModals"></div>

    <me-loading :loading="loading"></me-loading>

      <div class="signup">
        <form action="javascript:;" class="form">
          <div class="signup__step signup__step--01" v-show="step == 1">
            <div class="stepForm">
              <div class="content__header" v-if="shouldCreatePassword">
                <h2 class="content__title">Cadastre uma senha</h2>
                <p class="content__description">
                  Digite o e-mail cadastrado e crie uma senha de acesso para a sua conta
                </p>
              </div>
              <div class="content__header" v-else>
                <h2 class="content__title">Redefina sua senha</h2>
                <p class="content__description">
                  Sua nova senha precisa ser diferente das últimas três senhas usadas.
                </p>
              </div>
              <div class="content">
                <div class="formLineBox">
                  <fieldset class="formLine" :class="{ active: iptEmail, error: $v.iptEmail.$error, focus: focus.iptEmail }">
                    <div class="inputBox">
                      <label for="iptEmail">E-mail *</label>
                      <input type="text" name="iptEmail" id="iptEmail"
                        v-model.trim="iptEmail"
                        @focus="iptFocus('iptEmail', $event)" @blur="iptBlur('iptEmail', $event)" @input="$v.iptEmail.$touch"
                      >
                      <p class="errorText">{{ errors.iptEmail }}</p>
                    </div>
                  </fieldset>
                </div>

                <CreatePasswordInput
                  inputLabel="Nova senha *"
                  v-model="newPassword"
                  :formError="$v.newPassword.$error"
                  @input="$v.newPassword.$touch"
                  ref="newPasswordInput"
                  strengthField
                />

                <PasswordInput
                  inputLabel="Confirmar nova senha *"
                  v-model="confirmPassword"
                  :inputHasError="$v.confirmPassword.$error"
                  :passwordErrorMessage="confirmPasswordMessage"
                  @input="$v.confirmPassword.$touch"
                />

                <div class="button__container">
                  <button
                    name="Avançar"
                    type="submit"
                    class="btnQuero"
                    @click="changePassword()"
                    :disabled="cantSubmitForm"
                  >
                    confirmar
                  </button>
                </div>
              </div> <!-- content -->
            </div>
          </div> <!-- step 01 -->

          <div class="signup__step signup__step--02" v-show="step == 2">
            <div class="formConfirmPassword formConfirm--form">
              <div class="success-message__container">
                <img class="success-message__icon" src="/images/registration/success-green.svg" alt="Sucesso">
                <div v-if="shouldCreatePassword">
                  <h2 class='success-message__title'>Senha cadastrada com sucesso!</h2>
                  <p class="success-message__text">Você já pode utilizar o Melhor Envio.</p>
                </div>
                <div v-else>
                  <h2 class='success-message__title'>Senha alterada com sucesso!</h2>
                  <p class="success-message__text">Você já pode voltar a utilizar o Melhor Envio.</p>
                </div>
                <button
                  name="Avançar"
                  type="submit"
                  class="button button--primary"
                  @click="login()"
                >
                  ACESSAR O MELHOR ENVIO
                </button>
              </div>
            </div>
          </div> <!-- step 02 -->
        </form>
      </div>

    <!-- error modal -->
    <transition name="fade">
      <modal-base
        v-if="modalAlert"
        :title='modal.title'
        class="lead-form__error-modal"
      >
        <template v-slot:close-icon>
          <svg class='modal__close-icon' @click="hideModal('modalAlert')">
            <use xlink:href='/images/svg-symbols.svg#close' />
          </svg>
        </template>
        <template v-slot:content>
          <p v-html="modal.text" :style="modal.type == 'other' ? 'text-align: center !important' : '' ">
            {{ !modal.text ? "Por favor, verifique suas informações." : ''}}
          </p>
        </template>
        <template v-slot:footer>

          <button v-if="modal.type == 'token' " class="button button--primary" @click="redirectToLogin(), hideModal('modalAlert')">
            {{ modal.closeButtonText }}
          </button>

          <button v-else-if="modal.type == 'token_import' " class="button button--primary" @click="redirectToSupport(), hideModal('modalAlert')">
            {{ modal.closeButtonText }}
          </button>

          <button v-else class="button button--primary" @click="hideModal('modalAlert')">
            {{ modal.closeButtonText }}
          </button>

        </template>
      </modal-base>
    </transition>

  </section>
</template>

<script>
  import { required, email, sameAs, minLength, maxLength } from 'vuelidate/lib/validators';

  import AwesomeMask from 'awesome-mask';

  import ModalBase from "commons/js/components/atoms/ModalBase.vue";
  import Tooltip from "commons/js/components/atoms/Tooltip.vue";

  import newPasswordRules from "commons/js/validators/newPasswordRules";
  import CreatePasswordInput from "commons/js/components/atoms/CreatePasswordInput.vue";
  import PasswordInput from "commons/js/components/atoms/PasswordInput.vue";
  import PasswordStrengthField from "commons/js/components/atoms/PasswordStrengthField.vue";

  export default {
    components: {
      ModalBase,
      "me-tooltip": Tooltip,
      CreatePasswordInput,
      PasswordInput,
      PasswordStrengthField
    },
    props: {
      token: {
        type: String,
        required: true
      },
      shouldCreatePassword: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        step: 1,
        loading: false,
        showMask: false,
        modalAlert: false,
        modal: {
          type: '',
          title: 'Senha inválida',
          text: '',
          closeButtonText: 'Tentar novamente'
        },

        iptEmail: '',
        iptConfirmaSenha: '',

        errorMessages: {
          required: "Campo obrigatório! Não esqueça de preenchê-lo.",
          maxLength: "Dado inválido! Verifique sua resposta.",
          email: "Endereço de e-mail inválido! Verifique sua resposta.",
          sameAsPassword: "As senhas não são iguais. Tente novamente.",
          password: "Senha fraca! Combine letras e números.",
        },

        errors: {
          iptEmail: ''
        },

        focus: {
          iptEmail: false
        },

        newPassword: '',
        confirmPassword: '',
        passwordTokenExpire: parseInt(MEConfig.get('password.token-expires'))/60,
        importTokenExpire: parseInt(MEConfig.get('password.user-import-token-expiration-time-in-minutes'))/1440
      }
    },

    directives: {
      'mask': AwesomeMask
    },

    computed: {
      confirmPasswordMessage() {
        return !this.confirmPassword ? this.errorMessages.required : this.errorMessages.sameAsPassword
      },

      cantSubmitForm() {
        return this.$v.$invalid;
      },
    },

    methods: {
      login() {
        window.location.href = '/painel';
      },
      redirectToLogin() {
        window.location.href = 'https://melhorenvio.com.br/login';
      },
      redirectToSupport() {
        window.location.href = 'https://melhorenvio.com.br/suporte';
      },
      iptFocus(ipt) {
        this.focus[ipt] = true;
      },
      iptBlur(ipt) {
        this.focus[ipt] = false;
        this.updateErrorMessage(ipt);
      },
      updateErrorMessage(key) {
        let errorTypes = Object.keys(this.errorMessages);
        for (let i = 0; i < errorTypes.length; i++) {
          let errorType = errorTypes[i];
          if (this.$v[key].hasOwnProperty(errorType) && !this.$v[key][errorType]) {
            this.errors[key] = '';
            if (this.errorMessages.hasOwnProperty(errorType)) {
              this.errors[key] = String(this.errorMessages[errorType])
                .replace(/__field__/, String(key).replace(/^ipt/, '').replace(/Change$/, ''));
            }
            break;
          }
        }
      },
      changePassword() {
        if (this.$v.$invalid) {
          this.$v.$touch();
          this.$refs.newPasswordInput.touch();

          Object.keys(this.$v.$params).forEach((e) => {
            this.updateErrorMessage(e);
          });
          return;
        }
        this.loading = true;
        axios.post('/password/reset', {
          token: this.token,
          email: this.iptEmail,
          password: this.newPassword,
          password_confirmation: this.confirmPassword,
          had_random_password: this.shouldCreatePassword,
        }, {
          headers: {
            'Accept': 'application/json'
          }
        }).then(() => {
          this.$scrollTo('.signup');
          this.loading = false;
          this.step = 2;
        }).catch((error) => {
          let { status, data } = error.response;

          if (status == 403) {
            switch (data.type) {
              case 'passwords.token':
                this.makeTokenExpiredMessage();
                break;
              case 'passwords.user':
                this.modal.type = 'user';
                this.modal.title = 'Verifique o e-mail digitado';
                this.modal.text = `
                  Ele é diferente do e-mail cadastrado na sua conta Melhor Envio.
                `;
                this.modal.closeButtonText = 'Tentar novamente';
                break;
              default:
                this.modal.type = 'other';
                this.modal.text = data.message;
            }
          }

          if (status == 422) {
            this.modal.type = 'other';
            const passwordErrors = data.errors[Object.keys(data.errors)[0]];
            const flattenedPasswordErrors = [].concat.apply([], passwordErrors);
            this.modal.text = flattenedPasswordErrors[0];
          }

          if (status === 429) {
            this.modal.type = 'other';
            this.modal.text = "Você fez muitas tentativas, tente novamente em alguns minutos.";
          }

          if (status == 500) {
            this.modal.type = 'other';
            this.modal.text = `Ops! Ocorreu um erro inesperado no sistema. <br> Por favor tente novamente em alguns minutos.`;
          }

          this.$scrollTo('.signup');
          this.loading = false;
          this.showModal('modalAlert');

        });
      },
      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
      },
      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
      },
      hideAllModals() {
        this.showMask = false;
        this.modalAlert = false;
      },
      makeTokenExpiredMessage() {
        if (this.shouldCreatePassword) {
          this.modal.type = 'token_import';
          this.modal.title = 'Este link expirou';
          this.modal.text = `
            Para garantir a segurança da sua conta, o link de cadastro de senha é válido por apenas
            ${this.importTokenExpire} ${this.importTokenExpire <= 1 ? 'dia' : 'dias'}
            . <br><br>
            Por favor, fale com nosso suporte para pedir outro link de cadastro de senha.`;
          this.modal.closeButtonText = 'Falar com suporte';
          return;
        }
        this.modal.type = 'token';
        this.modal.title = 'Ops, página expirada';
        this.modal.text = `
          Esta página expirou!
          Para garantirmos sua segurança pedido de alteração de senha
          é válido por apenas <strong>
          ${this.passwordTokenExpire} ${this.passwordTokenExpire <= 1 ? 'hora' : 'horas'}
          </strong>. <br>
          Por favor, solicite novamente o link de alteração.`;
        this.modal.closeButtonText = 'Alterar minha senha';
      }
    },

    validations: {
      iptEmail: {
        required,
        email
      },
       newPassword: {
        required,
        newPasswordRules,
        minLength: minLength(12),
        maxLength: maxLength(64)
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('newPassword')
      }
    }
  }
</script>


<style lang="stylus" scoped>
// lato font
.password-recovery
  font-family 'Lato', sans-serif
  padding 0 24px

.content
  &__header
    text-align center
    font-family 'Lato', sans-serif
    margin 52px 0 16px 0

  &__title
    font-size 24px
    text-transform uppercase
    line-height 28px
    color #3B3F51
    margin-bottom 10px
    font-weight bold

  &__description
    color #697882
    line-height 18px
    strong
      font-weight bold

.button
    padding 8px 32px
    border none
    border-radius 18px
    font-size 14px
    line-height 18px
    color #fff
    text-transform uppercase
    cursor pointer
    font-family 'Open Sans', sans-serif

    &--primary
      background-color #3598DC

    &--disabled
      background-color grey
      cursor not-allowed

    &__container
      width 100%
      margin-top 60px

      display flex
      justify-content flex-end
      align-items center

.success-message

  &__container
    height 60vh
    width 96%
    display flex
    flex-flow column nowrap
    justify-content center
    align-content center
    align-items center
    margin 0 auto

  &__title
    font-size 22px
    color #2BC866
    font-weight bold
    font-family 'Lato', sans-serif
    margin-top 24px

  &__text
    color #3B3F51
    font-size 14px
    font-family 'Lato', sans-serif
    margin 6px 0 24px 0

  &__icon
    width 104px
    height 104px
    color #2BC866

strong
  font-weight bold

.password-strength {
  padding-top 24px
}
</style>
